// @flow
import moment from 'moment';

import DateRange from 'common/domain/DateRange';
import { ALL_WEEK } from 'common/domain/week';
import type { DayOfWeek } from 'common/domain/DayOfWeek';
import { Interval } from 'statsradio/domain/reach';
import { isDevFlagEnabled } from '../../../../common/components/DevFlag';
import { getLastSevenDays, getPreviousFullWeekPeriod, yesterday } from './MetricsPeriods';
import { CentralMarket } from '../../centralMarkets/domain/CentralMarket';

export class MetricsMetadata {
  interpolated: boolean;

  constructor({ interpolated }: { interpolated: boolean }) {
    this.interpolated = interpolated;
  }

  static parseJson(data: Object) {
    return new MetricsMetadata({
      interpolated: data.interpolated || false,
    });
  }

  isMissingSampling() {
    return this.interpolated;
  }
}

type MetricsQueryData = {
  dateRange: DateRange,
  dateRangeCompared: DateRange | void,

  interval: Interval,
  days: DayOfWeek[],
  centralMarket: ?CentralMarket,
}

export class MetricsQuery {
  dateRange: DateRange;
  dateRangeCompared: DateRange | void;

  interval: Interval;
  days: DayOfWeek[];
  centralMarket: ?CentralMarket;

  constructor(data: MetricsQueryData) {
    this.dateRange = data.dateRange;
    this.dateRangeCompared = data.dateRangeCompared;
    this.interval = data.interval;
    this.days = data.days;
    this.centralMarket = data.centralMarket;
  }

  static fromJSON(data: Object) {
    return new MetricsQuery({
      dateRange: DateRange.fromISO(data.dateRange),
      dateRangeCompared: data.dateRangeCompared && DateRange.fromISO(data.dateRangeCompared),
      interval: Interval.fromJSON(data.interval),
      days: data.days,
      centralMarket: data.centralMarket && CentralMarket.parse(data.centralMarket),
    });
  }

  with(data: $Shape<MetricsQueryData>) {
    return new MetricsQuery({ ...this, ...data });
  }

  toJSON() {
    return {
      dateRange: this.dateRange.toISO(),
      dateRangeCompared: this.dateRangeCompared && this.dateRangeCompared.toISO(),
      interval: this.interval.toJSON(),
      days: this.days,
      centralMarket: this.centralMarket && this.centralMarket.toJSON(),
    };
  }
}

export const DEFAULT_METRICS_QUERY: MetricsQuery = new MetricsQuery({
  dateRange: isDevFlagEnabled('METRICS_V2') ? getPreviousFullWeekPeriod(yesterday()) : getLastSevenDays(),
  dateRangeCompared: undefined,
  days: ALL_WEEK,
  interval: new Interval({
    from: moment().startOf('day'),
    to: moment().endOf('day'),
    step: 60,
  }),
  centralMarket: undefined,
});



// WEBPACK FOOTER //
// ./src/statsradio/modules/metrics/domain/Metrics.js